import React from 'react'
import styled from 'styled-components'
import CheckIcon from '../icons/Check'

export interface AnswerItemBoxContainer {
  selected?: boolean
  isAnswer?: boolean
  disabled?: boolean
  row?: number
}

const AnswerItemBoxContainer = styled.li<AnswerItemBoxContainer>`
  margin: 4px;
  padding: 0 10px;
  color: #fff;
  display: flex;
  align-items: center;
  max-width: 240px;
  max-height: 64px;
  min-height: 45px;
  border-radius: 12px;
  width: calc(50% - 8px);
  height: ${(p) => `calc((100% / ${p.row}) - 8px)`};
  display: flex;
  font-size: 12px;
  box-sizing: border-box;
  justify-content: space-between;
  font-weight: bold;
  transition: opacity 0.2s ease-out;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
  &:active {
    opacity: 1;
  }

  ${(p) => p.disabled ? 'pointer-events: none;' : ''}

  border: 2px solid ${(p) => p.selected ? '#fff' : 'rgba(255, 255, 255, 0.12)'};
  color: ${(p) => p.isAnswer ? '#212121' : '#fff'};
  background-color:  ${(p) => p.isAnswer ? '#fff' : 'rgba(23, 23, 23, 0.7)'};
  ${(p) => p.isAnswer && p.disabled ? 'background-color:rgba(230,230,230,0.5);' : ''}
  ${(p) => p.isAnswer ? 'padding: 12px 12px; border: none;' : ''}
  ${(p) => !p.isAnswer && p.disabled ? 'opacity: 0.6;' : ''}
  
  @media (min-width: 896px) {
    font-size: 24px;
    max-width: 400px;
    max-height: 144px;
  }
`

const AnswerItemBoxText = styled.span`
  margin-right: 4px;
`

// https://abema.esa.io/posts/16867
export interface AnswerItem {
  text: string
  value: string      // memo: survey-master-dbのanswer_idが入る
  order?: number      // 回答の表示順
  fixOrder?: boolean  // 表示順がランダムの場合に
  exclusive?: boolean // マルチアンサーの場合に、この選択肢が選択された場合は他の選択肢を選択できないようにする
}

export interface AnswerItemProps extends AnswerItem {
  hasCheckboxIcon?: boolean
  selected?: boolean
  isAnswer?: boolean
  isChecked?: boolean
  onClick: (value: string) => void
  submit?: (value: string) => void
  disabled?: boolean
  row?: number
}

const AnswerItemBox: React.FC<AnswerItemProps> = (props) => {
  return (
    <AnswerItemBoxContainer {...{
      isAnswer: props.isAnswer,
      selected: props.selected,
      disabled: props.disabled,
      onClick: () => {
        props.onClick(props.value)
        props.submit && props.submit(props.value)
      },
      row: props.row
    }}
    >
      <AnswerItemBoxText>{props.text}</AnswerItemBoxText>
      {props.hasCheckboxIcon && <CheckIcon checked={props.selected} />}
    </AnswerItemBoxContainer>
  )
}

export default AnswerItemBox
